import css from 'styled-jsx/css';

const styles = css`
  .outer-colors-container {
    width: 100%;
    padding: 0 8px;
    margin-bottom: 8px;
  }
  .inner-colors-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .interior-colors {
    width: 204px;
    margin-bottom: 16px;
  }
  .exterior-colors {
    width: 298px;
  }
  .color-filter-selector {
    margin-bottom: 8px;
  }
`;

export default styles;
